export * from './areas.service';
import { AreasService } from './areas.service';
export * from './auth.service';
import { AuthService } from './auth.service';
export * from './buildings.service';
import { BuildingsService } from './buildings.service';
export * from './customers.service';
import { CustomersService } from './customers.service';
export * from './default.service';
import { DefaultService } from './default.service';
export * from './movements.service';
import { MovementsService } from './movements.service';
export * from './pOI.service';
import { POIService } from './pOI.service';
export * from './roles.service';
import { RolesService } from './roles.service';
export * from './sensors.service';
import { SensorsService } from './sensors.service';
export * from './users.service';
import { UsersService } from './users.service';
export * from './zones.service';
import { ZonesService } from './zones.service';
export const APIS = [AreasService, AuthService, BuildingsService, CustomersService, DefaultService, MovementsService, POIService, RolesService, SensorsService, UsersService, ZonesService];
